import TgIcon from '@/shared/assets/icons/telegramIcon.svg?react'
import { BaseDialog, BaseInput } from '@/shared/components'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import { useEffect, useState } from 'react'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
}

export const DialogCopyBots = ({ modalVisible, setModalVisible }: Props) => {
  const [nameTelegramChat, setNameTelegramChat] = useState('')

  useEffect(() => {
    if (modalVisible) {
      setNameTelegramChat('@Ivan_support')
    }
  }, [modalVisible])

  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={() => setModalVisible(false)}
      closeButtonName="Вернуться назад"
      closeButtonVariant="purple"
      title="Прохождение верификации"
    >
      <div className="flex flex-col items-start gap-3 px-3 py-4 border rounded-lg">
        <span className="text-text-secondary">
          Данному пользователю необходимо пройти процедуру верификации KYC.
        </span>
        <span className="text-text-secondary">
          Для прохождения верификации свяжитесь с саппортом. После прохождения процедуры, статус
          аккаунта изменится автоматически.
        </span>
        <span className="text-primary dark:text-primary-dark">Подробная инструкция</span>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <BaseInput
            onChange={() => {}}
            value={nameTelegramChat}
            placeholder="Telegram chat"
            variant="secondary"
            leftIcon={<TgIcon className="text-text-secondary" />}
            className="w-full"
          />
          <BaseCopyButton text={nameTelegramChat} color="primary" />
        </div>
        <div className="flex items-center gap-2">
          <BaseInput
            onChange={() => {}}
            value={nameTelegramChat}
            placeholder="Telegram chat"
            variant="secondary"
            leftIcon={<TgIcon className="text-text-secondary" />}
            className="w-full"
          />
          <BaseCopyButton text={nameTelegramChat} color="primary" />
        </div>
        <div className="flex items-center gap-2">
          <BaseInput
            onChange={() => {}}
            value={nameTelegramChat}
            placeholder="Telegram chat"
            variant="secondary"
            leftIcon={<TgIcon className="text-text-secondary" />}
            className="w-full"
          />
          <BaseCopyButton text={nameTelegramChat} color="primary" />
        </div>
      </div>
    </BaseDialog>
  )
}
